export default __webpack_public_path__ + "static/media/target.7e0e8dd4.png";